import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import {
	CreateMipClassifierDto,
	InvestorAssignmentDto,
	MipClassifierRes,
	UpdateMipClassifierDto,
} from '@dealstack/shared/lib/generated';

export const listMipClassifiers = async (params?: {
	classifiedType?: string;
	/**
	 * Tri-state archive filter:
	 *   undefined → no filter (active + archived)
	 *   true      → only archived
	 *   false     → only active
	 */
	isArchived?: boolean;
}) => {
	return await makeRequest<ApiV1.Response<MipClassifierRes[]>>({
		endpoint: API_PATHS.MIP_CLASSIFIER_GET,
		method: HTTP_METHOD.GET,
		queryString: {
			...(params?.classifiedType ? { classifiedType: params.classifiedType } : {}),
			...(typeof params?.isArchived === 'boolean' ? { isArchived: params.isArchived } : {}),
		},
	});
};

export const createMipClassifier = async (body: CreateMipClassifierDto) => {
	return await makeRequest<ApiV1.Response<MipClassifierRes>>({
		endpoint: API_PATHS.MIP_CLASSIFIER_POST,
		method: HTTP_METHOD.POST,
		body: JSON.stringify(body),
	});
};

export const updateMipClassifier = async (args: {
	mipClassifierId: string;
	body: UpdateMipClassifierDto;
}) => {
	return await makeRequest<ApiV1.Response<MipClassifierRes>>({
		endpoint: formatUnicorn(API_PATHS.MIP_CLASSIFIER_MIPCLASSIFIERID_PATCH, {
			mipClassifierId: args.mipClassifierId,
		}),
		method: HTTP_METHOD.PATCH,
		body: JSON.stringify(args.body),
	});
};

export const listClassifiersForInvestor = async (investorId: string) => {
	return await makeRequest<ApiV1.Response<MipClassifierRes[]>>({
		endpoint: formatUnicorn(API_PATHS.MIP_CLASSIFIER_BY_INVESTOR_INVESTORID_GET, {
			investorId,
		}),
		method: HTTP_METHOD.GET,
	});
};

export const attachInvestorsToClassifier = async (args: {
	mipClassifierId: string;
	body: InvestorAssignmentDto;
}) => {
	return await makeRequest<ApiV1.Response<void>>({
		endpoint: formatUnicorn(API_PATHS.MIP_CLASSIFIER_MIPCLASSIFIERID_INVESTORS_ATTACH_POST, {
			mipClassifierId: args.mipClassifierId,
		}),
		method: HTTP_METHOD.POST,
		body: JSON.stringify(args.body),
	});
};

export const detachInvestorsFromClassifier = async (args: {
	mipClassifierId: string;
	body: InvestorAssignmentDto;
}) => {
	return await makeRequest<ApiV1.Response<void>>({
		endpoint: formatUnicorn(API_PATHS.MIP_CLASSIFIER_MIPCLASSIFIERID_INVESTORS_DETACH_POST, {
			mipClassifierId: args.mipClassifierId,
		}),
		method: HTTP_METHOD.POST,
		body: JSON.stringify(args.body),
	});
};
